(function (w, d) {
	w.Confused = w.Confused || {};
	w.Confused.CookieModalFocus = function () {};

	w.Confused.CookieModalFocus.init = function () {
		const cookieWall = d.querySelector('.cnf-cookies_cookie-wall');
		let cookieModalLink;
		let cookieModalBtn;
		let hasTabbed = false;

		if (cookieWall) {
			cookieModalLink = cookieWall.querySelector('.cnf-cookies_cookie-policy-link');
			cookieModalBtn = cookieWall.querySelector('#button-essential-only');
		}

		function setFocus(element) {
			if (element) {
				element.focus();
			}
		}

		function onTabPress(event) {
			const cookieWallOpen = cookieWall.classList.contains('cnf-cookies_open');

			if (!cookieWallOpen) {
				return;
			}

			if (!hasTabbed) {
				if (event.key === 'Tab') {
					event.preventDefault();
					setFocus(cookieModalLink);
					hasTabbed = true;
				}
				return;
			}

			const activeElem = event.target;

			if (event.key === 'Tab') {
				if (!event.shiftKey) {
					if (activeElem === cookieModalBtn) {
						event.preventDefault();
						setFocus(cookieModalLink);
					}
				} else if (activeElem === cookieModalLink) {
					event.preventDefault();
					setFocus(cookieModalBtn);
				}
			}
		}

		if (!cookieModalLink || !cookieWall.classList.contains('cnf-cookies_open')) {
			return;
		}

		d.addEventListener('keydown', event => onTabPress(event));
	};
})(window, document);
